import { Box, IconButton, styled } from "@mui/material";

export const SettingButton = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "48px",
  height: "48px",
  position: "fixed",
  bottom: "16px",
  right: "16px",
  color: "#344767",
  boxShadow: "rgba(0, 0, 0, 0.12) 0rem 0.3125rem 0.625rem 0rem",
  borderRadius: "50%",
  backgroundColor: "#fff",
  cursor: "pointer",
  transition: "opacity 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
  "&:hover": {
    opacity: 0.7,
  },
}));

export const CloseButton = styled(IconButton)(() => ({
  position: "absolute",
  top: "34px",
  right: "20px",
}));
